/**
 * MaterialIcons stub for web platform
 * Re-exports the HTML-based MaterialIcons implementation
 */
import { MaterialIcons } from './htmlIconStubs';
export default MaterialIcons;
